/**
 * AdminSidebar - admin app navigation
 */
import { NavLink, Link, useNavigate } from "react-router-dom";
import {
    LayoutDashboard,
    Users,
    CreditCard,
    LifeBuoy,
    Mail,
    LogOut,
    Shield,
    Settings,
    MessageCircle,
    Store,
} from "lucide-react";
import { LOGO_URL } from "@/lib/brand";
import { useAuth } from "@/lib/auth";

const MENU = [
    { to: "/admin", label: "Painel", icon: LayoutDashboard, testid: "admin-sidebar-dashboard" },
    { to: "/admin/clientes", label: "Clientes", icon: Users, testid: "admin-sidebar-clients" },
    { to: "/admin/pagamentos", label: "Pagamentos", icon: CreditCard, testid: "admin-sidebar-payments" },
    { to: "/admin/publicidade", label: "Marketplace", icon: Store, testid: "admin-sidebar-ads" },
    { to: "/admin/chat", label: "Chat de Suporte", icon: MessageCircle, testid: "admin-sidebar-chat" },
    { to: "/admin/suporte", label: "Tickets", icon: LifeBuoy, testid: "admin-sidebar-support" },
    { to: "/admin/mensagens", label: "Contactos", icon: Mail, testid: "admin-sidebar-contact" },
    { to: "/admin/configuracoes", label: "Configura\u00e7\u00f5es", icon: Settings, testid: "admin-sidebar-settings" },
];

export default function AdminSidebar() {
    const { user, logout } = useAuth();
    const nav = useNavigate();

    return (
        <aside
            className="hidden lg:flex w-[280px] shrink-0 sticky top-0 h-dvh flex-col border-r border-border bg-card/40 backdrop-blur-md"
            data-testid="admin-sidebar"
        >
            <Link to="/admin" className="flex items-center gap-2 px-5 h-16 border-b border-border">
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-[#0B0B10] overflow-hidden">
                    <img src={LOGO_URL} alt="MeSafa" className="h-9 w-9 object-contain" />
                </span>
                <span className="font-display font-bold text-lg tracking-tight">
                    <span className="text-[#A78BFA]">me</span>
                    <span>Safa</span>
                </span>
                <span className="ml-1 px-1.5 py-0.5 rounded-md bg-[#6B21D9]/30 text-[10px] font-semibold text-[#A78BFA]">
                    ADMIN
                </span>
            </Link>

            <nav className="flex-1 overflow-y-auto scrollbar-thin py-4 px-3 space-y-1">
                {MENU.map((it) => {
                    const Icon = it.icon;
                    return (
                        <NavLink
                            key={it.to}
                            to={it.to}
                            end={it.to === "/admin"}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium ${
                                    isActive
                                        ? "sidebar-active text-foreground"
                                        : "text-muted-foreground hover:text-foreground hover:bg-white/5"
                                }`
                            }
                            data-testid={it.testid}
                        >
                            <Icon className="h-4 w-4" />
                            <span>{it.label}</span>
                        </NavLink>
                    );
                })}
            </nav>

            <div className="border-t border-border p-3">
                <div className="flex items-center gap-3 px-2 py-2">
                    <div className="h-9 w-9 rounded-full bg-gradient-to-br from-[#6B21D9] to-[#A78BFA] grid place-items-center text-white">
                        <Shield className="h-4 w-4" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="text-sm font-medium truncate">{user?.name}</div>
                        <div className="text-xs text-muted-foreground truncate">Administrador</div>
                    </div>
                    <button
                        onClick={() => {
                            logout();
                            nav("/");
                        }}
                        className="p-2 rounded-lg hover:bg-white/5 text-muted-foreground hover:text-foreground"
                        title="Sair"
                        data-testid="admin-sidebar-logout"
                    >
                        <LogOut className="h-4 w-4" />
                    </button>
                </div>
            </div>
        </aside>
    );
}
